import EngagementButtons from '@/app/components/EngagementButtons';
import SectionContainer from '@/app/components/SectionContainer/SectionContainer';
import { whyJoinMedrecruitCardData } from '@/app/modules/HomePageV2/staticData/whyJoinMedrecruitCardData';

import styles from './WhyMedrecruit.module.scss';
import { WhyJoinMedrecruitCard } from './components/WhyJoinMedrecruitCard/WhyJoinMedrecruitCard';

export const WhyMedrecruit = () => {
  return (
    <SectionContainer className={styles.whyMedrecruitContainer}>
      <h5>
        Why doctors <span>choose Medrecruit</span>
      </h5>
      <div className={styles.whyJoinMedrecruitCards}>
        {whyJoinMedrecruitCardData.map(card => (
          <WhyJoinMedrecruitCard
            key={card.description}
            description={card.description}
            solutionSpecialistImageSrc={card.solutionSpecialistImageSrc}
            width={card.width}
            height={card.height}
          />
        ))}
      </div>
      <EngagementButtons trackAction="Why join Medrecruit" className={styles.buttonContainer} />
    </SectionContainer>
  );
};
